import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiDialogTitle from 'ui-components/ui-dialog-title/UiDialogTitle';
import UiDialogContent from 'ui-components/ui-dialog-content/UiDialogContent';
import UiButton from 'ui-components/ui-button/UiButton';
import {
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
  TelegramShareButton,
} from 'react-share';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiTextField from 'ui-components/ui-text-field/UiTextField';
import { StyledShare, StyledShareDialog } from './Share.styles';

// کامپوننت اشتراک گذاری
const Share = ({ children, url, support = 'left' }) => {
  const [visible, setVisible] = useState(false);
  const [visibleCopyMessage, setVisibleCopyMessage] = useState(false);
  const urlRef = useRef(null);
  const { t } = useTranslation();

  /**
   * کپی لینک در کلیپ بورد
   * @param {*} e
   */
  const copyToClipboard = (e) => {
    /** انتخاب متن */
    e.current.select();

    /** ذخیره در کلیپ بورد */
    document.execCommand('copy');
    setVisibleCopyMessage(true);
    setTimeout(() => {
      setVisibleCopyMessage(false);
    }, 2000);
  };

  return (
    <StyledShare>
      {children(setVisible)}

      <StyledShareDialog
        open={visible}
        onClose={() => setVisible(false)}
        support={support}
        className='share-modal'
      >
        <UiDialogTitle>
          <div>{t('content:share')}</div>
          <div>
            <UiIcon
              className='close-icon'
              icon='ri-close-line'
              onClick={() => setVisible((x) => !x)}
            />
          </div>
        </UiDialogTitle>
        <UiDialogContent>
          <span className='label'>{t('common:shareOn')}</span>
          <div className='flex wrap'>
            <TelegramShareButton
              className='social-btn'
              url={url}
              openShareDialogOnClick={false}
              onClick={(a, b) => {
                window.open(b);
              }}
            >
              <UiIcon icon='ri-telegram-line' size={30} hover='#32AADD' />
              <div className='title'>{t('common:telegram')}</div>
            </TelegramShareButton>
            <WhatsappShareButton
              className='social-btn'
              url={url}
              openShareDialogOnClick={false}
              onClick={(a, b) => {
                window.open(b);
              }}
            >
              <UiIcon icon='ri-whatsapp-line' size={30} hover='#25D366' />
              <div className='title'>{t('common:whatsapp')}</div>
            </WhatsappShareButton>
            <EmailShareButton
              className='social-btn'
              url={url}
              openShareDialogOnClick={false}
              onClick={(a, b) => {
                window.open(b);
              }}
            >
              <UiIcon icon='ri-mail-line' size={30} hover='#FFB30F' />
              <div className='title'>{t('common:email')}</div>
            </EmailShareButton>
            <TwitterShareButton
              className='social-btn'
              url={url}
              openShareDialogOnClick={false}
              onClick={(a, b) => {
                window.open(b);
              }}
            >
              <UiIcon icon='ri-twitter-line' size={30} hover='#5AD1F6' />
              <div className='title'>{t('common:twitter')}</div>
            </TwitterShareButton>
          </div>
          <div className='copy-link'>
            <div className='address-label'>{t('common:copyLinkAddress')}</div>
            <div className='flex'>
              <UiTextField
                inputRef={urlRef}
                value={url}
                className='copy-link-input'
              />
              <UiButton
                variant='outlined'
                className='copy-link-btn'
                color='primary'
                onClick={() => copyToClipboard(urlRef)}
              >
                {t('common:copyAddress')}
              </UiButton>
            </div>
            {visibleCopyMessage && (
              <span className='copy-link-message'>
                {t('common:linkWasCopied')}
              </span>
            )}
          </div>
        </UiDialogContent>
      </StyledShareDialog>
    </StyledShare>
  );
};

Share.propTypes = {
  children: PropTypes.any,
  url: PropTypes.string,
  support: PropTypes.string,
};

export default Share;
